import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-common-file-upload',
  templateUrl: './common-file-upload.component.html',
  styleUrls: ['./common-file-upload.component.scss']
})
export class CommonFileUploadComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  public serverPath = environment.commonImageApi + 'Capture.png';
  @Input() type: any = "logo";
  @Input() typeOfLogo: any = "logoBG";
  @Input() productId: any;

  @Input() locations: any = "calsoftgroup.com";
  @Input() fileSizeLimit: number = 5 * 1024 * 1024;
  @Input() allowedMimeType: string[] = null;
  @Input() multiple: boolean = true;

  @Output() fileUploadResult = new EventEmitter();
  imageChangedEvent: any = '';
  imageCropper: any
  data1: any;
  data2: any;
  files1: [{}];
  files: any[] = [];
  fileName: any;
  row: any;
  uploadmsg: any;
  text: string;
  item: FileLikeObject;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }


  constructor(

    private fileUploadService: FileUploadService,
    private snackBar: MatSnackBar
    , private router: Router) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {
    const uploaderOptions: any = {
      isHTML5: true,
      maxFileSize: this.fileSizeLimit
    };
    if (this.allowedMimeType && this.allowedMimeType.length > 0) {
      uploaderOptions.allowedMimeType = this.allowedMimeType;
    } else {
      uploaderOptions.allowedFileType = ['image', 'video', 'txt', 'doc', 'pdf', 'xls', 'xlsx', 'docx'];
    }
    this.uploader = new FileUploader(uploaderOptions);

    this.uploader.onAfterAddingFile = (fileItem) => {
      if (this.multiple === false && this.uploader.queue.length > 1) {
        this.uploader.queue.splice(0, this.uploader.queue.length - 1);
      }
    };

    this.s();
    this.text = "Upload all";

  }

  getClass(i) {
    if (i == 'banner') return 'banner'
    else if (i == 'multi') return 'multi'
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  fileOverBase(event) {

  }
  fileOverAnother(event) {

  }

  uploadSubmit() {
    let files = this.getFiles();

    let data = new FormData();


    files.forEach((file) => {
      data.append('files', (file as any).rawFile, file.name);
    });

    // POST formData to Server
    this.fileUploadService.uploadFile(data, this.productId).subscribe(
      (res: any) => {
        var result = res;
        this.data1 = result;
        this.data1.forEach(res => {
          this.fileUploadResult.emit(res);
          this.data2 = res;

        });

      },
    );


  }

  upload() {

    this.text = "Processing";
    let files = this.getFiles();
    let data = new FormData();
    if (files.length > 0) {
      files.forEach((file) => {

        if (this.type == 'logo') {
          data.append('files', (file as any).rawFile, this.typeOfLogo);
        } else {
          data.append('files', (file as any).rawFile, file.name.replace(/\s/g, "_").replace(/\(/g, '_').replace(/\)/g, '_'));
        }

      });
      // POST formData to Server

      this.fileUploadService.normalUploadFiles(data, this.type, this.locations).subscribe(
        (res: any) => {
          this.data1 = res;
          if (res && res.status_code === '500') {
            this.snackBar.open(res.status_message || 'An error occurred during upload', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            this.text = "Upload all";
            this.uploader.clearQueue();
            if (this.myInputVariable) this.myInputVariable.nativeElement.value = "";
            return;
          }
          this.fileUploadResult.emit(res);
          this.text = "Upload all";
          if (this.type == 'logo') {
            this.myInputVariable.nativeElement.value = "";

          }
          this.uploader.clearQueue();


        }, error => {
          this.text = "Upload all";
        }
      );


    } else {
      this.text = "Upload all";
      alert("No Items Found")
    }
  }



  public uploader: FileUploader;



  @ViewChild("myInput")
  myInputVariable: ElementRef;


  s() {


    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      if (this.type === 'posSales' && filter.name !== 'fileSize') {
        this.snackBar.open("Only JPG, PNG, and WEBP image files are allowed.", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        if (this.myInputVariable) {
          this.myInputVariable.nativeElement.value = "";
        }
        this.uploader.clearQueue();
        return;
      }
      let message = '';
      let maxFileSize = 5 * 1024 * 1024;
      let queueLimit = 5;
      this.item = item;
      switch (filter.name) {
        case 'mimeType':
        case 'fileType':
          this.snackBar.open(`File "${item.name}" has an unsupported format. Allowed: ${(this.allowedMimeType || []).join(', ') || 'image files'}`, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        case 'fileSize':
          const limitMB = Math.round(this.fileSizeLimit / (1024 * 1024));
          this.snackBar.open(`The file could not be uploaded because it exceeds ${limitMB}MB, the maximum allowed size for uploads`, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 1000 });
          this.myInputVariable.nativeElement.value = "";
          this.uploader.clearQueue();
          break;
        default:
          break;
      }
    };

    this.uploader.onAfterAddingFile = (fileItem) => {
      if (this.type === 'posSales') {
        const fileName = fileItem.file.name.toLowerCase();
        const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp'];
        const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));
        if (!isValid) {
          this.snackBar.open("Only JPG, PNG, and WEBP image files are allowed.", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          fileItem.remove();
          if (this.myInputVariable) {
            this.myInputVariable.nativeElement.value = "";
          }
          return;
        }
      }
    };

  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
